const STATUS_LABELS = { 0: 'Draft', 1: 'Ready', 2: 'Accepted', 3: 'Rejected', 4: 'Superseded' };

const formatCurrency = (v) => new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(v || 0);

const formatDate = (d) => {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const STATUS_STYLES = {
  1: { bg: '#f0f4ff', color: '#3b5bdb' },
  2: { bg: '#f0faf4', color: '#0f766e' },
  3: { bg: '#fff1f0', color: '#c92a2a' },
  4: { bg: '#f5f5f5', color: '#888' }
};

function getVersionDisplayName(quotation) {
  const custom = String(quotation?.VersionLabel || '').trim();
  return custom || `v${quotation?.VersionNumber || ''}`;
}

function getVersionSubLabel(quotation) {
  const custom = String(quotation?.VersionLabel || '').trim();
  if (!custom) return null;
  return `v${quotation?.VersionNumber || ''}`;
}

export default function QuotationCard({ quotation, token, selected, onSelect, onAccept, hideAccept }) {
  const isAccepted = quotation.Status === 2 || quotation.acceptance;
  const canAccept = quotation.Status === 1 && !quotation.acceptance;
  const statusStyle = STATUS_STYLES[quotation.Status] || { bg: '#f5f5f5', color: '#888' };

  return (
    <div
      onClick={onSelect}
      style={{
        background: selected ? '#f8f9fb' : 'white',
        borderRadius: '10px',
        padding: '14px 16px',
        border: isAccepted ? '1.5px solid #0f766e' : selected ? '1.5px solid #1a1a1a' : '1px solid #eee',
        borderLeft: selected ? '2px solid #1a1a1a' : isAccepted ? '2px solid #0f766e' : '2px solid transparent',
        cursor: 'pointer',
        transition: 'background 0.15s, border-color 0.15s, box-shadow 0.15s',
        boxShadow: selected ? '0 1px 4px rgba(0,0,0,0.06)' : '0 1px 2px rgba(0,0,0,0.03)'
      }}
      onMouseEnter={(e) => {
        if (!selected) e.currentTarget.style.background = '#fafafa';
      }}
      onMouseLeave={(e) => {
        if (!selected) e.currentTarget.style.background = 'white';
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', minWidth: 0 }}>
            <span style={{ fontSize: '14px', color: '#1a1a1a', fontWeight: 600, whiteSpace: 'nowrap' }}>{getVersionDisplayName(quotation)}</span>
            {getVersionSubLabel(quotation) && (
              <span style={{ fontSize: '12px', color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{getVersionSubLabel(quotation)}</span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', minWidth: 0 }}>
            <span
              style={{
                padding: '1px 7px',
                borderRadius: '5px',
                fontSize: '10px',
                fontWeight: 600,
                letterSpacing: '0.02em',
                background: statusStyle.bg,
                color: statusStyle.color,
                flexShrink: 0
              }}
            >
              {STATUS_LABELS[quotation.Status]}
            </span>
            <div style={{ fontSize: '11px', color: '#aaa' }}>
              {quotation.lineCount} items
              {quotation.CreatedAt ? `  ·  ${formatDate(quotation.CreatedAt)}` : ''}
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          <div style={{ fontSize: '15px', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-0.01em' }}>{formatCurrency(quotation.totals?.standard || 0)}</div>
          <div style={{ fontSize: '10px', color: '#bbb' }}>excl. VAT</div>
        </div>
      </div>

      {quotation.totals?.optional > 0 && <div style={{ fontSize: '11px', color: '#aaa', marginTop: '4px' }}>+ {formatCurrency(quotation.totals.optional)} optional</div>}

      {isAccepted && quotation.acceptance && (
        <div style={{ marginTop: '8px', padding: '6px 10px', background: '#f0faf4', borderRadius: '6px', fontSize: '11px', color: '#0f766e' }}>
          Accepted by <strong>{quotation.acceptance.SignatoryName}</strong>
        </div>
      )}

      {canAccept && !hideAccept && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAccept(quotation);
          }}
          style={{
            marginTop: '10px',
            width: '100%',
            padding: '7px 0',
            fontSize: '12px',
            fontWeight: 600,
            border: 'none',
            borderRadius: '7px',
            background: '#1a1a1a',
            color: 'white',
            cursor: 'pointer',
            transition: 'background 0.15s'
          }}
          onMouseEnter={(e) => (e.target.style.background = '#333')}
          onMouseLeave={(e) => (e.target.style.background = '#1a1a1a')}
        >
          Accept
        </button>
      )}
    </div>
  );
}
